import React from 'react';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { Box, Button, Divider, Stack, Tooltip } from '@mui/material';

import { getBearingEnvelopeUserVisibleTerm } from '../../../../../../library/utilities/bearingEnvelopeUserTerm';
import { LayoutPointPickerField } from '../../../insertions/truss-envelope/LayoutPointPickerField';
import { BearingEnvelopeLengthTool } from './BearingEnvelopeLengthTool';
import { BearingEnvelopePropertiesProps } from './BearingEnvelopeProperties';
import { flipBearingEnvelope, FlippableBearingEnvelopeProperties } from './flipBearingEnvelope';

export function BearingEnvelopePointProperties(
  props: BearingEnvelopePropertiesProps & { onMoveRequested?: () => void },
) {
  const bearingTerm = getBearingEnvelopeUserVisibleTerm(props.properties.bearingType);

  return (
    <>
      <Box>
        <Stack direction="column" spacing={2}>
          <LayoutPointPickerField
            label="Start Point"
            target="bearing-envelope-left"
            disabled={props.disabled}
            value={props.properties.leftPoint}
          />

          <LayoutPointPickerField
            label="End Point"
            target="bearing-envelope-right"
            disabled={props.disabled}
            value={props.properties.rightPoint}
          />

          <Tooltip disableInteractive title={`Flip ${bearingTerm}`}>
            <Box component="span" sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                fullWidth
                startIcon={<SwapVertIcon />}
                disabled={props.disabled || props.properties.leftPoint == null || props.properties.rightPoint == null}
                onClick={() => {
                  props.onChange(flipBearingEnvelope(props.properties as FlippableBearingEnvelopeProperties));
                }}
              >
                Flip {bearingTerm}
              </Button>
            </Box>
          </Tooltip>
        </Stack>
      </Box>

      <Divider />

      <BearingEnvelopeLengthTool disabled={props.disabled} properties={props.properties} onChange={props.onChange} />
    </>
  );
}
